'use client'

import { useRequest } from '@/hooks/use-request'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { z } from 'zod'

const forgotPasswordSchema = z.object({
  email: z.string().email(),
})

export function useForgotPasswordMutation() {
  return useMutation({
    mutationFn: async (data: { email: string }) =>
      useRequest().post('auth/forgot-password', forgotPasswordSchema.parse(data)),
    onSuccess: ({ data }) => {
      toast.success(data?.message || 'Password reset link sent successfully')
    },
  })
}
